module.exports = __webpack_public_path__ + "static/media/242 Park - Concept Drawing 2(1).064d4235.jpg";